import { useState, useRef } from "react";
import { CircleButton } from "../common/CircleButton/circle-button";
import {
  ItemTypePicker,
  ItemTypeOption,
  PickerPosition,
} from "../common/ItemTypePicker";
import { ItemType } from "../../types";
import "./tab.css";

type TabProps = {
  label: string;
  icon?: string;
  isActive: boolean;
  onClick: () => void;
  isEditMode?: boolean;
  canAdd?: boolean;
  itemTypes?: ItemTypeOption[];
  itemTypesLoading?: boolean;
  onItemTypeSelect?: (itemType: ItemType) => void;
};

export const Tab = ({
  label,
  icon,
  isActive,
  onClick,
  isEditMode,
  canAdd = true,
  itemTypes = [],
  itemTypesLoading = false,
  onItemTypeSelect,
}: TabProps) => {
  const [showPicker, setShowPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState<PickerPosition>({
    top: 0,
    left: 0,
  });
  const buttonContainerRef = useRef<HTMLDivElement>(null);

  const handleAddClick = () => {
    if (buttonContainerRef.current) {
      const rect = buttonContainerRef.current.getBoundingClientRect();
      setPickerPosition({
        top: rect.bottom + 4,
        left: rect.left,
      });
    }
    setShowPicker(true);
  };

  const handleItemTypeSelect = (itemType: ItemType) => {
    onItemTypeSelect?.(itemType);
    setShowPicker(false);
  };

  return (
    <div className={`tab__wrapper ${isActive ? "active" : ""}`}>
      <button className={`tab__button`} onClick={onClick}>
        {icon && <span className="tab__icon">{icon} </span>}
        <span className="tab__button-label">{label}</span>
      </button>
      {isEditMode && canAdd && (
        <div className="tab__edit-indicator" ref={buttonContainerRef}>
          <CircleButton
            onClick={handleAddClick}
            ariaLabel={`Add to ${label}`}
            iconKey="add"
            size="small"
          />
          {showPicker && (
            <ItemTypePicker
              itemTypes={itemTypes}
              isLoading={itemTypesLoading}
              onSelect={handleItemTypeSelect}
              onClose={() => setShowPicker(false)}
              position={pickerPosition}
            />
          )}
        </div>
      )}
    </div>
  );
};
